<template>
  <div class="form-control filter-picker">
    <input
      ref="ip"
      type="text"
      class="filter-entry"
      v-model.trim="keywords"
      :class="className"
      :placeholder="placeholder"
      @focus="onFocus"
      @blur="onBlur" style="color:#6b7d8e">
    <ul class="picker-wrapper" v-show="visible">
      <li class="picker-item" v-for="(item, index) in list">
        <a href="javascript:;" @click="onItemClick(index)">{{item[field]}}</a>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'FilterPicker',
    props: {
      className: [String, Object],
      source: {
        type: Array,
        default () {
          return []
        }
      },
      field: {
        type: String,
        default: 'text'
      },
      delay: {
        type: Number,
        default: 200
      },
      value: String,
      placeholder: String
    },
    data () {
      return {
        keywords: '',
        visible: false,
        list: []
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.keywords && this.hideSpan(this.$refs.ip, this.keywords)
      })
    },
    watch: {
      keywords: 'onChange',
      source: 'onChange',
      value (val) {
        this.keywords = val
      }
    },
    methods: {
      hideSpan (ele, prop) {
        if (prop.trim().length !== 0 && this.$browser.name === 'IE' && this.$browser.version === '9.0') {
          let oWrapper = ele.previousElementSibling
          oWrapper.style.display = 'none'
        }
      },
      showSpan (ele, prop) {
        if (prop.trim().length === 0 && this.$browser.name === 'IE' && this.$browser.version === '9.0') {
          let oWrapper = ele.previousElementSibling
          oWrapper.style.display = 'inline-block'
        }
      },
      doFilter () {
        let code = escape(this.keywords).replace(/%u/g, '\\u')
        let reg = new RegExp('(' + code + ')')
        this.list = this.source.filter((item, index) => {
          if (reg.test(item[this.field])) {
            return item
          }
        })
      },
      onChange () {
        clearTimeout(this.__actionTimer)
        this.__actionTimer = setTimeout(() => {
          if (this.keywords.length) {
            this.$nextTick(() => {
              this.keywords && this.hideSpan(this.$refs.ip, this.keywords)
            })
            this.doFilter()
          } else {
            this.keywords && this.showSpan(this.$refs.ip, this.keywords)
            this.list = [].concat(this.source)
          }
        }, this.delay)
      },
      onFocus () {
        clearTimeout(this.__showTimer)
        this.visible = true
      },
      onBlur () {
        this.__showTimer = setTimeout(() => {
          if (this.keywords !== this.value) {
            this.keywords = ''
          }
          this.visible = false
        }, this.delay)
      },
      onItemClick (index) {
        let item = this.list[index]
        clearTimeout(this.__showTimer)
        this.__showTimer = setTimeout(() => {
          this.visible = false
          this.$emit('onItemSelected', item)
        }, this.delay)
        // 解决银行支行名称选择之后span无法隐藏的问题
        if (this.$browser.name === 'IE' && this.$browser.version === '9.0') {
          let oWrapper = this.$refs.ip.previousElementSibling
          oWrapper.style.display = 'none'
        }
      }
    }
  }
</script>

<style lang="stylus">
  @import '../../stylus/filter-picker'
</style>



// WEBPACK FOOTER //
// filter.vue?13900014